import { json } from 'd3';
import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['pagination', 'entries', 'errorMessage', 'platform', 'bulkIds', 'singleId', 'bulkImportHandler'];
  pagination_rendered = []

  beforeFilter() {
    this.progressBar = new Turbolinks.ProgressBar();
    this.progressBar.setValue(0);
    this.progressBar.show();
  }

  afterFilter() {
    this.progressBar.setValue(1);
    this.progressBar.hide();
  }

  connect() {
    if(this.hasBulkIdsTarget) $(this.bulkIdsTarget).hide();
    $('#pagination').hide()
    $('#spinner').hide()
  }

  addChannel(event) {
    var platform = $(this.platformTarget).val().toLowerCase();
    var text = $(this.bulkImportHandlerTarget).text();
    var channel_id = $("input[name=channel_id]").val().trim();
    if(text != "Import a list") {
      channel_id = $(this.bulkIdsTarget).val().trim();
    }
    if(platform == "tiktok") {
      var regex = RegExp('^(https?\:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$');
      if(regex.test(channel_id)) {
        $(this.errorMessageTarget).text('Please enter TikTok URL');
        event.preventDefault();
        return;
      }
    }
    else if(platform == "youtube") {
      var regex = RegExp('tiktok.com');
      if(regex.test(channel_id)) {
        $(this.errorMessageTarget).text('Please enter YouTube URL');
        event.preventDefault();
        return;
      }
    }
    var $this = $(event.target).find(':submit');
    var loadingText = '<i class="fa fa-circle-o-notch fa-spin"></i>';
    $this.html(loadingText);
    $this.prop('disabled', true);
  }

  createChannel(event) {
    $(event.target).find(".spinner-border").show();
    $(event.target).attr("disabled", true);

    let container = $(event.target).parents(".new-channel-form:first");
    let platform_name = container.find(".platform_values").val();
    let url_or_handle = container.find(".url-field input").val();
    let channel_type = container.find(".type-field input").val();
    let entity_type = $("#channels_fields #entity_type").val()

    let channel_list_container = "#fields-container .list-group"
    var remove_button = `<button class="ml-1 btn btn-outline-danger remove-field-button" type="button"><i class='fa fa-times' aria-hidden='true'></i></button>`

    let data = {"channel": { "platform_name": platform_name, "channel_uid": url_or_handle, "channel_type": channel_type} }

    Rails.ajax({
      type: 'POST',
      url: `/channels`,
      data: $.param(data),
      dataType: 'json',
      success: (response) => {
        container.remove();

        $(event.target).find(".spinner-border").hide();
        $(event.target).html(response.message);

        $(channel_list_container).append("<li class='channel-container list-group-item d-flex justify-content-between align-items-center'></li>")
        $(channel_list_container + " .channel-container:last").html(response)
        $(channel_list_container + " .channel-container:last").append(remove_button)

        var id = $(channel_list_container + " .channel-container:last").find(".channel_id:first").val()
        $(channel_list_container + " .channel-container:last").append(`<input class="channel_id" name="${entity_type}[channel_ids][]" value="${id}" type="hidden">`)
      },
      error: (response) => {
        container.find(".notice-field .alert").text(response.message);
        container.find(".notice-field").show();
        $(event.target).attr("disabled", false);
        $(event.target).find(".spinner-border").hide();
      }
    })
  }

  clearError() {
    $(this.errorMessageTarget).text('');
  }

  handleBulkImport() {
    var text = $(this.bulkImportHandlerTarget).text();
    if(text == "Import a list") {
      $(this.singleIdTarget).prop("required", false);
      $(this.bulkIdsTarget).prop("required", true);
      $(this.singleIdTarget).hide();
      $(this.bulkIdsTarget).show();
      $(this.bulkImportHandlerTarget).text('Single Import');
      $("input[name=is_bulk]").val(1);
    }
    else {
      $(this.singleIdTarget).prop("required", true);
      $(this.bulkIdsTarget).prop("required", false);
      $(this.singleIdTarget).show();
      $(this.bulkIdsTarget).hide();
      $(this.bulkImportHandlerTarget).text("Import a list");
      $("input[name=is_bulk]").val(0);
    }
  }

  addToList(event) {
    var $this = $(event.target);
    var loadingText = '<i class="fas fa-circle-notch fa-spin"></i>';
    $this.html(loadingText);
    $this.addClass('disabled');
  }

  scroll(){
    let next_page = this.paginationTarget.querySelector("a[rel='next']")
    if(next_page == null) { return }

    let url = next_page.href
    var body = document.body

    if(window.pageYOffset >= body.scrollHeight - window.innerHeight){
      this.loadMore(url)
    }
  }

  loadMore(url){
    $('#spinner').show();
    Rails.ajax({
      type: 'GET',
      url: url,
      dataType: 'json',
      success: (data) => {
        var ids = data.ids
        var flag = ids.every(v => this.pagination_rendered.includes(v))

        if (!flag) {
          this.pagination_rendered = this.pagination_rendered.concat(ids)
          this.entriesTarget.insertAdjacentHTML('beforeend', data.entries)
          this.paginationTarget.innerHTML = data.pagination

          // var columns_array = ['following', 'likes', 'total_views', 'languages', 'locations', 'affiliations','blocked_in', 'labels',
          // 'entity_types', 'total_engagement','engagement_growth_velocity', 'engagement_growth_acceleration', 'total_shares', 'total_posts']
          // columns_array.forEach(function(columnClass){
          //   var elements = $(`.${columnClass}`)
          //   var checkboxElement = $(`#${columnClass}`)
          //   if (checkboxElement.is(':checked')) {
          //     elements.removeClass('d-none')
          //   }
          // })
          if($('#showLeaderboardThumbnails').prop('checked')){
            this.loadPosts([ids])
          }
        }
        $('[data-toggle="tooltip"]').tooltip()

        $('#spinner').hide();
      }

    })
  }

  leaderboardChannelIds(){
    const chunkify = (arr, size) => arr.reduce((acc, e, i) => (i % size ? acc[acc.length - 1].push(e) : acc.push([e]), acc), []);

    var ids = []
    $('#leaderboard-table tr').each(function() {
      ids.push(parseInt(this.id.replace('channel-posts-',''))); 
    })

    if(ids.length > 150){
      return chunkify(ids, 150);
    } else {
      return [ids];
    }
    
  }

  showThumbnailsToggleHandler(){
    var checked = $('#showLeaderboardThumbnails').prop('checked')

    if(checked){
      $('.video-thumbnails').remove();
      var ids = this.leaderboardChannelIds()
      this.loadPosts(ids)
    } else {
      $('.video-thumbnails').hide();
    }
  }

  loadPosts(ids){
    console.log(ids)
    for (var arr of ids){
      var channel_ids = arr.join(",")
      var url = '/fetch_latest_posts';

      Rails.ajax({
        type: 'POST',
        url: url + "?channel_ids=" + channel_ids,
        dataType: 'json',
        success: (response) => {
          this.renderPosts(response)
        }
      })
    }
  }

  renderPosts(data){
    for (var channel_id of Object.keys(data)) {
      var html = "<tr id='channel-posts-"+ channel_id + "' class='video-thumbnails'>" + "<td class='recent-posts' colspan='9'>" + "<div class='row'>" + "<div class='d-flex align-items-center ml-3 mr-3 font-weight-bold'> Recent Posts: </div></div></td></tr>";
      $('#leaderboard-table tr#' + channel_id).after(html);

      for (var post_id of Object.keys(data[channel_id])){
        var img_url = data[channel_id][post_id]["img_url"]
        var link = data[channel_id][post_id]["link"]
        $('#channel-posts-' + channel_id + ' .row').append("<a target='_blank' href='"+ link +"'><img class='table-thumbnail' src='"+ img_url +"'/></a>")
      }
    }
  }

  toggleColumn(event){
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);
    let columns = params.getAll('choose_columns[]');
    let currentSelectedColumns = []

    if(columns.length < 1) {
      columns = ['followers', 'following', 'total_posts', 'total_engagement', 'likes']
    }

    params.delete('choose_columns[]')
    $('.choose_columns_dropdown input:checked').each(function(i, elem){
      let column_id = elem.id.replace("table-column-", "")
      params = params +`&choose_columns[]=`+column_id;
      currentSelectedColumns.push(column_id)
    })

    url = new URL(window.location.href.split('?')[0] + '?' + params.toString())
    window.history.pushState(null,null, url);

    columns.forEach((elem) => {
      $('.' + elem).addClass('d-none')
    })
    currentSelectedColumns.forEach((elem) => {
      $('.' + elem).removeClass('d-none')
    })
  }

  // updateKeyFilters(event){
  //   let url = new URL(window.location.href);
  //   let params = new URLSearchParams(url.search);

  //   $('.channel-attribute-dropdown-filter').each(function(i, elem){
  //     let element_name = '.' + elem.dataset.type + '-' + elem.dataset.name
  //     if ($(elem).is(":checked")) {
        
  //       if ($(element_name).length == 0){
  //         params.append(`${elem.dataset.type}[${elem.dataset.name}]`, [])
  //       }
  //     } else {
  //       params.delete(`${elem.dataset.type}[${elem.dataset.name}]`)
  //     }
  //   })

  //   $(event.target).parents(".dropdown.attribute-selector:first").find(".dropdown-toggle").dropdown('toggle');
  //   window.location.href = window.location.href.split('?')[0] + '?' + params.toString()
  // }

  addKeyFilter(event) {
    if (event.target.checked) {
      let url = '/channels/add_key_filter?'
      let params = new URLSearchParams()
      params.set("id", event.target.dataset.id)

      Rails.ajax({
        type: 'GET',
        url: url + params,
        dataType: 'json',
        success: (response) => {
          $('#dynamic_filters').append(response)
        }
      })
    } else {
      let removeElement = '.' + event.target.dataset.type + '-' + event.target.dataset.name
      $(removeElement).find('input[type=checkbox]:checked').removeAttr('checked');
      this.searchKeyFilter();

      $(removeElement).remove();
    }
  }

  searchKeyFilter() {
    filter_names = []
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);

    $('.dynamic-filter-dropdown .dropdown-menu').each(function(i, elem){
      var filter_name = $(elem).attr('name')

      params.delete(`${elem.dataset.filterType}[${filter_name}]`)
      if (url.pathname == '/submission_reviews' && params.toString().includes('user%5B')) {
        params.delete(`user[${params.toString().split('user%5B')[1].split('%5D')[0]}]`)
      }

      var checked = $(`.${filter_name}-dropdown-filter:checkbox:checked`)
      let values = []

      checked.each(function(i, element) {
        values.push(element.id)
      });

      if (values.length != 0) {
        params.append(`${elem.dataset.filterType}[${filter_name}]`, values)
      }
    })

    window.location.href = window.location.href.split('?')[0] + '?' + params.toString()
  }

  isTrackedClick(event) {
    var url = window.location.pathname + '?';
    let params = new URLSearchParams(window.location.search)
    if ($(event.target).is(':checked')) {
      params.set('is_tracked', true)
    } else {
      params.delete('is_tracked')
    }
    window.location.href = url + params
  }

  removedClick(event) {
    var url = window.location.pathname + '?';
    let params = new URLSearchParams(window.location.search)
    if ($(event.target).is(':checked')) {
      params.set('content_removed', true)
    } else {
      params.delete('content_removed')
    }
    window.location.href = url + params
  }

  isVerifiedClick(event) {
    var url = window.location.pathname + '?';
    let params = new URLSearchParams(window.location.search)
    if ($(event.target).is(':checked')) {
      params.set('channel_verified', 1)
    } else {
      params.delete('channel_verified')
    }
    window.location.href = url + params
  }

  statsDate(event) {
    var url = window.location.pathname + '?';
    let params = new URLSearchParams(window.location.search)
    params.set(event.target.id, event.target.value)
    window.location.href = url + params
  }

  searchQuery(event) {
    event.preventDefault();
    this.beforeFilter();
    var form = $("#post_filter")
    var url = $(event.target).attr("action")

    var qs = form.serializeJSON();
    let params = new URLSearchParams(window.location.search);

    params.delete("term");
    params.delete("simple_query");
    params.delete("substring_search");
    params.delete("include_bios");

    var new_params = jQuery.param(qs)
    params = params + "&" + new_params

    url += "?" + params
    console.log(url)
    window.location.href = url
  }


  searchKeyAttributes(event) {
    var search = $(event.target).val().trim().toLowerCase();
    $(".dynamic-add-checkbox").each(function () {
      if ($(this).text().toLowerCase().indexOf(search) < 0){
        $(this).hide()
      } else {
        $(this).show()
        $(this).children('ul')?.first()?.addClass('show')
      }
    })
  }

  viewFilter(event){
    let params = new URLSearchParams(window.location.search)
    params.set('view_as', event.target.value);
    window.location.href = window.location.href.split('?')[0] + '?' + params
  }

  addReportRowFilter(event) {
    let url = '/channels/add_report_filter?'
    let params = new URLSearchParams()
    params.set("id", event.target.value)

    Rails.ajax({
      type: 'GET',
      url: url + params,
      dataType: 'json',
      success: (response) => {
        $('#report-row-filters').html(response)
      }
    })
  }

  addReportColumnFilter(event) {
    let url = '/channels/add_report_filter?'
    let params = new URLSearchParams()
    params.set("id", event.target.value)

    Rails.ajax({
      type: 'GET',
      url: url + params,
      dataType: 'json',
      success: (response) => {
        $('#report-column-filters').html(response)
      }
    })
  }

  generateChannelReport() {
    let params = new URLSearchParams(window.location.search)
    params.delete('row_key')
    params.delete('row_value')
    params.delete('column_key')
    params.delete('column_value')
    params.delete('metric')

    let values = []
    let key = []

    $('#report-row-filters .dropdown-filter:checkbox:checked').each(
      function(i, elem) {
        key = elem.dataset.attr
        values.push(elem.dataset.value)
      }
    );

    if (values.length != 0) {
      params.append('row_key', key)
      params.append('row_value', values)
    }

    key = []
    values = []
    $('#report-column-filters .dropdown-filter:checkbox:checked').each(
      function(i, elem) {
        key = elem.dataset.attr
        values.push(elem.dataset.value)
      }
    );

    if (values.length != 0) {
      params.append('column_key', key)
      params.append('column_value', values)
    }

    params.append('metric', $('#select_metric').val())

    window.location.href = window.location.href.split('?')[0] + '?' + params
  }
}
